import { css } from 'styled-components';

const sharedTitleStlyes = css`
  color: ${({ textColor }) => textColor};
  font-family: var(--font-family);
  font-size: ${({ textSize }) =>
    textSize === 'h1'
      ? '61px'
      : textSize === 'h2'
      ? '49px'
      : textSize === 'h3'
      ? '39px'
      : textSize === 'h4'
      ? '31px'
      : textSize === 'h5'
      ? '25px'
      : textSize === 'h6' && '20px'};
  font-weight: 900;
  line-height: ${({ textSize, lineHeightMobile, lineHeightDesktop }) =>
    lineHeightDesktop
      ? lineHeightDesktop
      : lineHeightMobile
      ? lineHeightMobile
      : textSize === 'h1'
      ? '110%'
      : textSize === 'h2'
      ? '110%'
      : textSize === 'h3'
      ? '110%'
      : textSize === 'h4'
      ? '110%'
      : textSize === 'h5'
      ? '120%'
      : textSize === 'h6' && '120%'};
  letter-spacing: ${({ textSize, letterSpacing }) =>
    letterSpacing
      ? letterSpacing
      : textSize === 'h1'
      ? '-0.05em'
      : textSize === 'h2'
      ? '-0.04em'
      : textSize === 'h3'
      ? '-0.04em'
      : textSize === 'h4'
      ? '-0.03em'
      : textSize === 'h5'
      ? '-0.02em'
      : textSize === 'h6' && '-0.01em'};
  margin: ${({
    headingSpacingDesktop,
    headingSpacingMobile,
    marginDesktop,
    marginMobile,
    removeTextSpacing,
  }) =>
    removeTextSpacing
      ? 0
      : headingSpacingDesktop || headingSpacingMobile || marginDesktop || marginMobile};
  text-align: ${({ alignMobile, alignDesktop }) => {
    return alignDesktop || alignMobile;
  }};
  width: 100%;

  @media (max-width: 768px) {
    font-size: ${({ textSize }) =>
      textSize === 'h1'
        ? '32px'
        : textSize === 'h2'
        ? '29px'
        : textSize === 'h3'
        ? '26px'
        : textSize === 'h4'
        ? '23px'
        : textSize === 'h5'
        ? '20px'
        : textSize === 'h6' && '18px'};
    letter-spacing: ${({ textSize, letterSpacing }) =>
      letterSpacing
        ? letterSpacing
        : textSize === 'h1'
        ? '-0.3%'
        : textSize === 'h2'
        ? '-0.3%'
        : textSize === 'h3'
        ? '-0.2%'
        : textSize === 'h4'
        ? '-0.2%'
        : textSize === 'h5'
        ? '-0.1%'
        : textSize === 'h6' && '0'};
    line-height: ${({ lineHeightMobile }) => lineHeightMobile};
    margin: ${({ headingSpacingMobile, marginMobile, removeTextSpacing }) =>
      removeTextSpacing ? 0 : headingSpacingMobile || marginMobile};
    text-align: ${({ alignMobile }) => alignMobile};
  }
`;

const paragraphStyles = css`
  color: ${({ textColor }) => textColor};
  font-family: var(--font-family);
  font-size: ${({ textSize }) =>
    textSize === 'large'
      ? '25px'
      : textSize === 'medium'
      ? '20px'
      : textSize === 'normal'
      ? '16px'
      : textSize === 'small'
      ? '13px'
      : textSize};
  font-weight: 500;
  letter-spacing: ${({ textSize }) => (textSize === 'lg' ? '-0.01%' : '0')};
  line-height: ${({ lineHeightDesktop, lineHeightMobile }) =>
    lineHeightDesktop || lineHeightMobile};
  margin: ${({
    paragraphSpacingDesktop,
    paragraphSpacingMobile,
    marginDesktop,
    marginMobile,
    removeTextSpacing,
  }) =>
    removeTextSpacing
      ? 0
      : paragraphSpacingDesktop || paragraphSpacingMobile || marginDesktop || marginMobile};
  text-align: ${({ alignMobile, alignDesktop }) => alignDesktop || alignMobile};
  white-space: pre-wrap;
  width: 100%;

  @media (max-width: 768px) {
    font-size: ${({ textSize }) =>
      textSize === 'large'
        ? '20px'
        : textSize === 'medium'
        ? '17px'
        : textSize === 'normal'
        ? '16px'
        : textSize === 'small'
        ? '13px'
        : textSize};
    line-height: ${({ lineHeightMobile }) => lineHeightMobile};
    margin: ${({ marginMobile, paragraphSpacingMobile, removeTextSpacing }) =>
      removeTextSpacing ? 0 : paragraphSpacingMobile || marginMobile};
    text-align: ${({ alignMobile }) => alignMobile};
  }
`;

const overlineStyles = css`
  color: ${({ textColor }) => textColor || 'var(--neutral-5)'};
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.05em;
  line-height: 110%;
  margin: ${({ headingSpacingDesktop, headingSpacingMobile }) =>
    headingSpacingDesktop || headingSpacingMobile || '0 0 15px 0'};
  text-align: ${({ alignMobile, alignDesktop }) => alignDesktop || alignMobile};
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 14px;
    text-align: ${({ alignMobile }) => alignMobile};
    margin: ${({ headingSpacingMobile }) => headingSpacingMobile || '0 0 15px 0'};
  }
`;

export { sharedTitleStlyes, overlineStyles, paragraphStyles };
